import React from 'react'
import { connect } from "react-redux"
import { withRouter } from 'react-router'
import { setTitle } from "../../actions"
import backgroundImg from '../../images/background.jpg'

@connect((store) => {
    return {
      User: store.User.User,
      app: store.app,
      practices: store.practices,
      practice_types: store.practice_types
    };
})

class OwnerDashboard extends React.Component {
    constructor(props) {
        super(props);
        this.goToPractice = this.goToPractice.bind(this)
    }

    componentWillMount() {
        const { dispatch } = this.props;
        dispatch(setTitle('My Practices'));
    }

    componentDidUpdate() {
        const { User, router } = this.props;

        if (User.ownPractices.length === 1) {
            router.replace(`/practice_admin/${User.ownPractices[0]._id}`)
        }
    }

    goToPractice(practice) {
        const { router } = this.props;
        router.push(`/practice_admin/${practice._id}`)
    }

    render() {
        const { User } = this.props;
        return (<main className="main ownerDashView"><br /> {
            User.ownPractices.map((practice, i) => {
                const style = {
                    'height': '104px',
                    'backgroundPosition': 'center',
                    'backgroundSize': 'cover',
                    'justifyContent': 'flex-start',
                    'minHeight': '120px',
                    'backgroundColor': 'rgba(0,0,0,0.2)',
                    'backgroundBlendMode': 'multiply',
                    'backgroundImage': practice.backgroundImg
                        ? `url(${practice.backgroundImg.scaled})`
                        : `url(${backgroundImg})`
                }
                return (<div key={practice._id} onClick={() => {
                    this.goToPractice(practice)
                }
                } className="card link" style={style}>
                    <div className="card-content sub-title-bar-content row">
                        {
                            practice.logo
                                ? <img width="72" alt="Logo" className="logo" src={practice.logo.thumb} />
                                : null
                        }
                        <h5 className="padding">{practice.name}</h5>
                    </div>
                </div>)
            })
        }
        </main>)
    }

}

export default withRouter(OwnerDashboard)



// WEBPACK FOOTER //
// ./src/components/owner/OwnerDashboard.jsx